import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetUrlTitleDetailsQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	episodeMaxLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	platform?: Types.Platform;
	allowSponsoredRecommendations?: Types.InputMaybe<Types.SponsoredRecommendationsInput>;
}>;

export type GetUrlTitleDetailsQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		metaDescription?: string | null;
		metaKeywords?: string | null;
		metaRobots?: string | null;
		metaTitle?: string | null;
		heading1?: string | null;
		heading2?: string | null;
		htmlContent?: any | null;
		node:
			| { __typename: 'Article'; id: string }
			| { __typename: 'Author'; id: string }
			| { __typename: 'Bundle'; id: string }
			| { __typename: 'Device'; id: string }
			| { __typename: 'Episode'; id: string }
			| { __typename: 'GenericTitleList'; id: string }
			| { __typename: 'Genre'; id: string }
			| {
					__typename: 'Movie';
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					permanentAudiences: Array<string>;
					id: string;
					disneyOffersCount: number;
					plexPlayerOffers: Array<{
						__typename?: 'Offer';
						id: string;
						standardWebURL?: string | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							technicalName: string;
							shortName: string;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						monetizationType: Types.MonetizationType;
						elementCount?: number | null;
						package: { __typename?: 'Package'; id: string; packageId: number; clearName: string };
					}>;
					watchNowOffer?: { __typename?: 'Offer'; id: string; standardWebURL?: string | null } | null;
					promotedBundles: Array<{ __typename?: 'PromotedBundleEdge'; promotionUrl: string }>;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'MovieContent';
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
					};
					content: {
						__typename?: 'MovieContent';
						originalTitle: string;
						ageCertification?: string | null;
						productionCountries: Array<any>;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						credits: Array<{
							__typename?: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
						}>;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
						genres: Array<{ __typename?: 'Genre'; shortName: string }>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
							} | null;
						}>;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{
						__typename?: 'TitleListEntry';
						createdAt: any;
						genericTitleList: { __typename?: 'GenericTitleList'; id: string };
					}>;
					similarTitlesV2: {
						__typename?: 'SimilarTitlesConnection';
						sponsoredAd?: {
							__typename?: 'SponsoredRecommendationAd';
							bidId: string;
							holdoutGroup: boolean;
							campaign: { __typename?: 'SponsoredRecommendationCampaign'; hideRatings: boolean };
						} | null;
					};
					seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| { __typename: 'MultiStepSportEvent'; id: string }
			| { __typename: 'Offer'; id: string }
			| { __typename: 'Package'; id: string }
			| { __typename: 'Page'; id: string }
			| { __typename: 'Person'; id: string }
			| {
					__typename: 'Season';
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					totalEpisodeCount: number;
					id: string;
					disneyOffersCount: number;
					plexPlayerOffers: Array<{
						__typename?: 'Offer';
						id: string;
						standardWebURL?: string | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							technicalName: string;
							shortName: string;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						monetizationType: Types.MonetizationType;
						elementCount?: number | null;
						package: { __typename?: 'Package'; id: string; packageId: number; clearName: string };
					}>;
					watchNowOffer?: { __typename?: 'Offer'; id: string; standardWebURL?: string | null } | null;
					promotedBundles: Array<{ __typename?: 'PromotedBundleEdge'; promotionUrl: string }>;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'SeasonContent';
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
					};
					content: {
						__typename?: 'SeasonContent';
						seasonNumber: number;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
						genres: Array<{ __typename?: 'Genre'; shortName: string }>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
							} | null;
						}>;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					episodes: Array<{
						__typename?: 'Episode';
						id: string;
						objectType: Types.ObjectType;
						objectId: number;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'EpisodeContent';
							title: string;
							shortDescription?: string | null;
							episodeNumber: number;
							seasonNumber: number;
							isReleased: boolean;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								label: Types.UpcomingReleaseLabel;
								package?: { __typename?: 'Package'; id: string; packageId: number } | null;
							}>;
						};
					}>;
					show: {
						__typename?: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						totalSeasonCount: number;
						customlistEntries: Array<{
							__typename?: 'TitleListEntry';
							createdAt: any;
							genericTitleList: { __typename?: 'GenericTitleList'; id: string };
						}>;
						tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						fallBackClips: {
							__typename?: 'ShowContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
							}>;
						};
						content: {
							__typename?: 'ShowContent';
							title: string;
							ageCertification?: string | null;
							fullPath: string;
							productionCountries: Array<any>;
							posterUrl?: string | null;
							isReleased: boolean;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
							}>;
						};
						seenState: { __typename?: 'ShowSeenState'; progress: number };
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						similarTitlesV2: {
							__typename?: 'SimilarTitlesConnection';
							sponsoredAd?: {
								__typename?: 'SponsoredRecommendationAd';
								bidId: string;
								holdoutGroup: boolean;
								campaign: { __typename?: 'SponsoredRecommendationCampaign'; hideRatings: boolean };
							} | null;
						};
					};
					seenState: { __typename?: 'ShowSeenState'; progress: number };
			  }
			| {
					__typename: 'Show';
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					permanentAudiences: Array<string>;
					totalSeasonCount: number;
					id: string;
					disneyOffersCount: number;
					plexPlayerOffers: Array<{
						__typename?: 'Offer';
						id: string;
						standardWebURL?: string | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							technicalName: string;
							shortName: string;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						monetizationType: Types.MonetizationType;
						elementCount?: number | null;
						package: { __typename?: 'Package'; id: string; packageId: number; clearName: string };
					}>;
					watchNowOffer?: { __typename?: 'Offer'; id: string; standardWebURL?: string | null } | null;
					promotedBundles: Array<{ __typename?: 'PromotedBundleEdge'; promotionUrl: string }>;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'ShowContent';
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
					};
					content: {
						__typename?: 'ShowContent';
						originalTitle: string;
						ageCertification?: string | null;
						productionCountries: Array<any>;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						credits: Array<{
							__typename?: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
						}>;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
						genres: Array<{ __typename?: 'Genre'; shortName: string }>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
							} | null;
						}>;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{
						__typename?: 'TitleListEntry';
						createdAt: any;
						genericTitleList: { __typename?: 'GenericTitleList'; id: string };
					}>;
					similarTitlesV2: {
						__typename?: 'SimilarTitlesConnection';
						sponsoredAd?: {
							__typename?: 'SponsoredRecommendationAd';
							bidId: string;
							holdoutGroup: boolean;
							campaign: { __typename?: 'SponsoredRecommendationCampaign'; hideRatings: boolean };
						} | null;
					};
					seenState: { __typename?: 'ShowSeenState'; progress: number; seenEpisodeCount: number };
					tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					seasons: Array<{
						__typename?: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						totalEpisodeCount: number;
						availableTo: Array<{
							__typename?: 'AvailableTo';
							availableToDate: any;
							availableCountDown: number;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
						content: {
							__typename?: 'SeasonContent';
							posterUrl?: string | null;
							seasonNumber: number;
							fullPath: string;
							title: string;
							isReleased: boolean;
							originalReleaseYear?: number | null;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
								package?: { __typename?: 'Package'; id: string; shortName: string } | null;
							}>;
						};
						show: {
							__typename?: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							content: { __typename?: 'ShowContent'; title: string };
						};
					}>;
					recentEpisodes: Array<{
						__typename?: 'Episode';
						id: string;
						objectId: number;
						content: {
							__typename?: 'EpisodeContent';
							title: string;
							shortDescription?: string | null;
							episodeNumber: number;
							seasonNumber: number;
							isReleased: boolean;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								label: Types.UpcomingReleaseLabel;
							}>;
						};
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					}>;
			  }
			| { __typename: 'SingleStepSportEvent'; id: string }
			| { __typename: 'SportCompetitionV2'; id: string }
			| { __typename: 'SportCompetitorV2'; id: string }
			| { __typename: 'Url'; id: string };
	};
};

export type TrailerClipsFragment = {
	__typename?: 'Clip';
	sourceUrl: string;
	externalId: string;
	provider: Types.ClipProvider;
	name: string;
};

export const TrailerClipsFragmentDoc = gql`
	fragment TrailerClips on Clip {
		sourceUrl
		externalId
		provider
		name
	}
`;
export const GetUrlTitleDetailsDocument = gql`
	query GetUrlTitleDetails(
		$fullPath: String!
		$country: Country!
		$language: Language!
		$episodeMaxLimit: Int
		$platform: Platform! = WEB
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
	) {
		urlV2(fullPath: $fullPath) {
			id
			metaDescription
			metaKeywords
			metaRobots
			metaTitle
			heading1
			heading2
			htmlContent
			node {
				id
				__typename
				... on MovieOrShowOrSeason {
					plexPlayerOffers: offers(country: $country, platform: $platform, filter: { packages: ["pxp"] }) {
						id
						standardWebURL
						package {
							id
							packageId
							clearName
							technicalName
							shortName
						}
					}
					disneyOffersCount: offerCount(country: $country, platform: $platform, filter: { packages: ["dnp"] })
					objectType
					objectId
					offerCount(country: $country, platform: $platform)
					offers(country: $country, platform: $platform) {
						monetizationType
						elementCount
						package {
							id
							packageId
							clearName
						}
					}
					watchNowOffer(country: $country, platform: $platform) {
						id
						standardWebURL
					}
					promotedBundles(country: $country, platform: $platform) {
						promotionUrl
					}
					availableTo(country: $country, platform: $platform) {
						availableCountDown(country: $country)
						availableToDate
						package {
							id
							shortName
						}
					}
					fallBackClips: content(country: "US", language: "en") {
						videobusterClips: clips(providers: [VIDEOBUSTER]) {
							...TrailerClips
						}
						dailymotionClips: clips(providers: [DAILYMOTION]) {
							...TrailerClips
						}
					}
					content(country: $country, language: $language) {
						backdrops {
							backdropUrl
						}
						fullBackdrops: backdrops(profile: S1920, format: JPG) {
							backdropUrl
						}
						clips {
							...TrailerClips
						}
						videobusterClips: clips(providers: [VIDEOBUSTER]) {
							...TrailerClips
						}
						dailymotionClips: clips(providers: [DAILYMOTION]) {
							...TrailerClips
						}
						externalIds {
							imdbId
						}
						fullPath
						genres {
							shortName
						}
						posterUrl
						fullPosterUrl: posterUrl(profile: S718, format: JPG)
						runtime
						isReleased
						scoring {
							imdbScore
							imdbVotes
							tmdbPopularity
							tmdbScore
						}
						shortDescription
						title
						originalReleaseYear
						originalReleaseDate
						upcomingReleases(releaseTypes: DIGITAL) {
							releaseCountDown(country: $country)
							releaseDate
							label
							package {
								id
								packageId
								shortName
								clearName
							}
						}
						... on MovieOrShowContent {
							originalTitle
							ageCertification
							credits {
								role
								name
								characterName
								personId
							}
							productionCountries
						}
						... on SeasonContent {
							seasonNumber
						}
					}
					popularityRank(country: $country) {
						rank
						trend
						trendDifference
					}
				}
				... on MovieOrShow {
					watchlistEntryV2 {
						createdAt
					}
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					customlistEntries {
						createdAt
						genericTitleList {
							id
						}
					}
					similarTitlesV2(country: $country, allowSponsoredRecommendations: $allowSponsoredRecommendations) {
						sponsoredAd {
							bidId
							holdoutGroup
							campaign {
								hideRatings
							}
						}
					}
				}
				... on Movie {
					permanentAudiences
					seenlistEntry {
						createdAt
					}
				}
				... on Show {
					permanentAudiences
					totalSeasonCount
					seenState(country: $country) {
						progress
						seenEpisodeCount
					}
					tvShowTrackingEntry {
						createdAt
					}
					seasons(sortDirection: DESC) {
						id
						objectId
						objectType
						totalEpisodeCount
						availableTo(country: $country, platform: $platform) {
							availableToDate
							availableCountDown(country: $country)
							package {
								id
								shortName
							}
						}
						content(country: $country, language: $language) {
							posterUrl
							seasonNumber
							fullPath
							title
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
								releaseCountDown(country: $country)
								package {
									id
									shortName
								}
							}
							isReleased
							originalReleaseYear
						}
						show {
							id
							objectId
							objectType
							watchlistEntryV2 {
								createdAt
							}
							content(country: $country, language: $language) {
								title
							}
						}
					}
					recentEpisodes: episodes(sortDirection: DESC, limit: 3, releasedInCountry: $country) {
						id
						objectId
						content(country: $country, language: $language) {
							title
							shortDescription
							episodeNumber
							seasonNumber
							isReleased
							upcomingReleases {
								releaseDate
								label
							}
						}
						seenlistEntry {
							createdAt
						}
					}
				}
				... on Season {
					totalEpisodeCount
					episodes(limit: $episodeMaxLimit) {
						id
						objectType
						objectId
						seenlistEntry {
							createdAt
						}
						content(country: $country, language: $language) {
							title
							shortDescription
							episodeNumber
							seasonNumber
							isReleased
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
								label
								package {
									id
									packageId
								}
							}
						}
					}
					show {
						id
						objectId
						objectType
						totalSeasonCount
						customlistEntries {
							createdAt
							genericTitleList {
								id
							}
						}
						tvShowTrackingEntry {
							createdAt
						}
						fallBackClips: content(country: "US", language: "en") {
							videobusterClips: clips(providers: [VIDEOBUSTER]) {
								...TrailerClips
							}
							dailymotionClips: clips(providers: [DAILYMOTION]) {
								...TrailerClips
							}
						}
						content(country: $country, language: $language) {
							title
							ageCertification
							fullPath
							genres {
								shortName
							}
							credits {
								role
								name
								characterName
								personId
							}
							productionCountries
							externalIds {
								imdbId
							}
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
							}
							backdrops {
								backdropUrl
							}
							posterUrl
							isReleased
							videobusterClips: clips(providers: [VIDEOBUSTER]) {
								...TrailerClips
							}
							dailymotionClips: clips(providers: [DAILYMOTION]) {
								...TrailerClips
							}
						}
						seenState(country: $country) {
							progress
						}
						watchlistEntryV2 {
							createdAt
						}
						dislikelistEntry {
							createdAt
						}
						likelistEntry {
							createdAt
						}
						similarTitlesV2(
							country: $country
							allowSponsoredRecommendations: $allowSponsoredRecommendations
						) {
							sponsoredAd {
								bidId
								holdoutGroup
								campaign {
									hideRatings
								}
							}
						}
					}
					seenState(country: $country) {
						progress
					}
				}
			}
		}
	}
	${TrailerClipsFragmentDoc}
`;
